import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  readonly _loading$ = new BehaviorSubject<boolean>(true);

  constructor(private router: Router) {
    // Track navigation and set loading accordingly
    this.router.events
      .pipe(
        filter(
          event =>
            event instanceof NavigationStart ||
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError
        )
      )
      .subscribe(event => {
        if (event instanceof NavigationStart) {
          this.setLoading(true);
          return;
        }
        // End navigation
        this.setLoading(false);
      });
  }

  setLoading(val: boolean): void {
    if (this._loading$.getValue() !== val) {
      this._loading$.next(val);
    }
  }

  get loading$(): Observable<boolean> {
    return this._loading$.asObservable();
  }
}
